/**
 * Recursively trims all string values in an object or array.
 * This is useful for cleaning form data before submission.
 * 
 * @param {any} obj - The object or array to trim.
 * @returns {any} - A new object or array with all string values trimmed.
 */
export function trimObjectValues(obj) {
    // If it's not an object (and not null), or if it's a string, just return the trimmed value if string
    if (obj === null || typeof obj !== 'object') {
        return typeof obj === 'string' ? obj.trim() : obj;
    }

    // Special case for Date object: don't try to recurse into it
    if (obj instanceof Date) {
        return obj;
    }

    // If it's an array, map over its elements
    if (Array.isArray(obj)) {
        return obj.map(trimObjectValues);
    }

    // If it's a plain object, reduce its keys and trim values recursively
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, trimObjectValues(value)])
    );
}
